import store from '../store';
import { api } from '@/utils/fetch.js';
import { getQueryString } from './tools.js';

export const checkPhoneHasSame = async (phoneVal, formItem) => {
  let hasSame = false;
  const isViewSubmit = !!getQueryString('view_submit');
  const submitForm = {
    id: getQueryString('form_id'),
    search_fields: {
      [`${formItem.id}.value`]: {
        "operator": "contain",
        "value": phoneVal
      }
    }
  };
  const phoneCount = await api.CountFormSubmitField(submitForm, true).then((res) => {
    return res?.total || 0;
  }).catch((e) => {
    return 0;
  });

  // 判断是否自己提交过的手机号
  let isMySubmitPhone = false;
  if (isViewSubmit) {
    const submitDetailPhone = store.state.submitDetail?.data?.[formItem.id]?.value;
    isMySubmitPhone = submitDetailPhone === phoneVal;
  }

  if (phoneCount >= 1 && !isMySubmitPhone) {
    hasSame = true;
  }
  return hasSame;
}